export default "__VITE_ASSET__i7slO72q__"